const MetamaskIcon = (props: any) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_414_27340)">
      <path
        d="M30.564 0.0976562L17.875 9.42217L20.1821 3.94281L30.564 0.0976562Z"
        fill="#E17726"
        stroke="#E17726"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.43652 0.0976562L13.9333 9.51829L11.7223 3.94281L1.43652 0.0976562Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0462 21.8223L22.6816 26.9171L29.8913 28.9358L31.91 21.9184L26.0462 21.8223Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.0898438 21.9184L2.10855 28.9358L9.31824 26.9171L5.95372 21.8223L0.0898438 21.9184Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.93473 13.0743L6.91602 16.0543L14.0296 16.3427L13.8373 8.65234L8.93473 13.0743Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.066 13.0743L18.0673 8.65234L17.875 16.4388L24.9886 16.1504L23.066 13.0743Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.31836 26.9167L13.6442 24.8018L9.89513 21.918L9.31836 26.9167Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3555 24.8018L22.6813 26.9167L22.1045 21.918L18.3555 24.8018Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.6813 26.9159L18.3555 24.801L18.74 27.5888V28.7423L22.6813 26.9159Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.31836 26.9152L13.3558 28.8378V27.6842L13.7403 24.8965L9.31836 26.9152Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3566 20.0918L9.7998 19.0344L12.2992 17.8809L13.3566 20.0918Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5469 20.0918L19.6043 17.8809L22.1037 19.0344L18.5469 20.0918Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.3196 26.9171L9.89637 21.8223L5.95508 21.9184L9.3196 26.9171Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0078 21.8223L22.5846 26.9171L25.9491 21.9184L22.0078 21.8223Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0843 16.1484L17.9707 16.4368L18.6436 20.0897L19.701 17.8788L22.2004 19.0323L25.0843 16.1484Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.79989 19.0323L12.2992 17.8788L13.3567 20.0897L14.0296 16.4368L6.91602 16.1484L9.79989 19.0323Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.91602 16.1484L9.89602 22.0123L9.79989 19.1284L6.91602 16.1484Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.2006 19.0327L22.1045 21.9166L25.0845 16.0527L22.2006 19.0327Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.0293 16.4375L13.3564 20.0904L14.2216 24.4162L14.4139 18.7446L14.0293 16.4375Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8748 16.4375L17.4902 18.7446L17.6825 24.4162L18.5477 20.0904L17.8748 16.4375Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5478 20.0926L17.6826 24.4184L18.2594 24.8029L22.0084 21.919L22.1046 19.0352L18.5478 20.0926Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.7998 19.0352L9.89593 21.919L13.645 24.8029L14.2217 24.4184L13.3566 20.0926L9.7998 19.0352Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.6439 28.8384V27.6848L18.3555 27.3964H13.549L13.2606 27.6848V28.8384L9.31934 26.9158L10.7613 28.0693L13.549 29.9919H18.4516L21.3355 28.0693L22.6813 26.9158L18.6439 28.8384Z"
        fill="#C0AC9D"
        stroke="#C0AC9D"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3546 24.8005L17.7778 24.416H14.2211L13.6443 24.8005L13.2598 27.5883L13.5482 27.2999H18.3546L18.643 27.5883L18.3546 24.8005Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0445 10.0951L32.1019 4.90411L30.4677 0.0976562L18.3555 9.13378L23.0658 13.0751L29.6987 14.9976L31.1406 13.2673L30.4677 12.8828L31.5252 11.9215L30.7561 11.3447L31.8135 10.5757L31.0445 10.0951Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M-0.197266 4.90411L0.860154 10.0951L0.18725 10.5757L1.24467 11.3448L0.475638 11.9215L1.53306 12.8828L0.860154 13.3635L2.30209 15.0938L8.93499 13.1712L13.6453 9.22991L1.43693 0.0976562L-0.197266 4.90411Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.6987 14.9968L23.0658 13.0742L25.0845 16.0542L22.1045 21.9181L26.0458 21.822H31.9097L29.6987 14.9968Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.93372 13.0742L2.30081 14.9968L0.0898438 21.822H5.95372L9.89501 21.9181L6.91501 16.0542L8.93372 13.0742Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8744 16.4382L18.2589 9.13237L20.1815 3.94141H11.626L13.5486 9.13237L13.9331 16.4382L14.1253 18.7453V24.4169H17.6821V18.7453L17.8744 16.4382Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_414_27340">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default MetamaskIcon;
